import { LABELS } from "~/resources/Labels";
import { TableHeaderType } from "../types/TableHeaderType";

export const ScriptsHeader: TableHeaderType[] = [
    {
      label: LABELS.DeploymentScriptIDTitle,
      key: 'scriptIdentify',
      id: 'scriptIdentify.deploymentScriptId',
      sortable: false,
    },
    {
      label: LABELS.Provider,
      key: "provider",
      id: 'provider',
      sortable: true,
    },
    {
      label:LABELS.Environment,
      key: "environment",
      id: 'environment',
      sortable: true,
    },
    {
      label: LABELS.Title,
      key: 'title',
      id: 'title',
      sortable: true,
    },
    {
      label: "Type",
      key: 'scriptType',
      id: 'scriptType',
      sortable: true,
    },
    {
      id: 'creationDate',
      label: LABELS.DateAdded,
      alignment: '',
      sortable: true,
      key: 'creationDate',
    },

    {
      id: 'actions',
      label:'',
      alignment: '',
      sortable: false,
      key: '',
    },
  ];
